import { axiosInstance as axios } from '../../axios/axios';
import * as Action from '../actions/index';
import customizeError, { getErrorMsg } from '../../utils/customizeError';
import { localStorageFunc } from './../../utils/localStorage';

export const token = localStorageFunc('get','','token');

export const login = (data, setLoading, navigate) => {
  return async (dispatch) => {
    try {
      setLoading(true);
      const res = await axios.post('/api/login', data);
      dispatch({ type: Action.LOGIN, payload: res.data });
      setLoading(false);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: {
          msg: `Welcome ${res.data.user.firstname} ${res.data.user.lastname}`,
          type: 'success',
        },
      });

      localStorageFunc('save', res.data.token, 'token');
      navigate('/');
    } catch (err) {
      const msg = getErrorMsg(err);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg, type: 'error' },
      });
      setLoading(false);
    }
  };
};

export const register = (data, setLoading, navigate) => {
  return async (dispatch) => {
    try {
      setLoading(true);
      await axios.post('/api/register', data);
      dispatch({ type: Action.REGISTER });
      setLoading(false);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: {
          msg: 'Signup Successful.Redirecting to login',
          type: 'success',
        },
      });
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      if (err.response) {
        dispatch({
          type: Action.CREATE_ERROR,
          payload: { msg: customizeError(err.response.data), type: 'error' },
        });
      }

      setLoading(false);
    }
  };
};

export const logout = (token, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      await axios.post('/api/logout', null, config);
      setLoading(false);
      localStorageFunc('remove');
      token = null;
      dispatch({ type: Action.LOGOUT });
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg: 'User logged out', type: 'success' },
      });
      navigate('/');
    } catch (err) {
      setLoading(false);
      const msg = getErrorMsg(err);
      if (err.response) {
        dispatch({
          type: Action.AUTHERROR,
          payload: msg,
        });
      }
    }
  };
};
